import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import { getVipTag, getIncomeSource, isAppStorePay } from '@/utils/vip';
import AvatarDefault from '@/assets/image/vip/avatar-default.png';
import Pro from '@/assets/image/new-ui/pro.png';
import Vip from '@/assets/image/new-ui/vip.png';
import NoVip from '@/assets/image/new-ui/no-vip.png';
import { getUrlParam } from '@/utils';
import { TabType } from '@/constants/subscription';
import { SubscribeType, subscribeType } from '@/constants';
import { useAtom } from 'jotai';
import { message } from 'antd';
import {
  curTabAtom,
  hasFetchUserInfoAtom,
  meidouTotalAtom,
  userInfoAtom,
  vipInfoAtom,
  visibleExchangeAtom,
  visibleInvoicingAtom,
  visibleMeidouInfoModalAtom,
} from '@/store';
import { track } from '@/utils/common';
import { handleJumpLogin } from '@/utils/user';
import ArrowImg from '@/assets/image/new/right-arrow.png';

import styles from './index.module.css';
import { useLocaleStore } from '@/i18n/localeStore';

const Userinfo = () => {
  const { $t } = useLocaleStore();
  const type = getUrlParam('type'); // PC端订阅URL里定义的参数，区分是会员还是批处理

  const [curTab, setCurTab] = useAtom(curTabAtom);
  const [hasFetchUserInfo] = useAtom(hasFetchUserInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [meidouTotal] = useAtom(meidouTotalAtom);
  const [, setVisibleMeidouInfoModal] = useAtom(visibleMeidouInfoModalAtom);
  const [, setVisibleInvoicing] = useAtom(visibleInvoicingAtom);
  const [, setVisibleExchange] = useAtom(visibleExchangeAtom);

  const handleJumpAccount = () => {
    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }

    const url = `https://${prefix}account.meitu.com/#!/account`;

    if (getIncomeSource() === 'MTXX-WEB') {
      window.open(url);
    } else {
      // native.openBrowser(url);
    }
  };

  const handleMeidouInfoClick = () => {
    setVisibleMeidouInfoModal(true);
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'surplus',
      },
    });
  };

  const handleSwitch = () => {
    const value = curTab === TabType.MEIDOU ? TabType.SUB : TabType.MEIDOU;

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: value === TabType.MEIDOU ? 'buymeidou' : 'buyvip',
      },
    });

    setCurTab(value);
  };

  const renderDesc = () => {
    if (!userInfo?.id) {
      return isAppStorePay()
        ? $t((v) => v.Text_LoginToBuyMember)
        : type === 'svip'
        ? $t((v) => v.Text_LoginToBuy)
        : $t((v) => v.Text_LoginToBuyMemberShort);
    }

    return (
      <>
        <div style={{ cursor: 'initial', display: 'flex', alignItems: 'center' }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            style={{ marginRight: 4 }}
          >
            <path
              d="M8.01706 4.51164C7.92891 4.31691 7.75287 4.19673 7.56723 4.2367C7.37465 4.27816 7.27406 4.46769 7.29296 4.68434C7.41997 6.14023 7.9627 7.19613 8.99998 7.91658C9.17058 8.03507 9.39894 8.07518 9.54059 7.91798C9.67744 7.76609 9.63358 7.53478 9.50162 7.33208C9.13489 6.7688 8.39378 5.3438 8.01706 4.51164Z"
              fill="#616366"
            />
            <path
              d="M2.35526 3.80345C3.03924 2.13603 4.33214 0.583496 6.32064 0.583496C7.49793 0.583496 8.30204 1.06776 8.86067 1.74764C9.37913 2.37865 9.67801 3.17189 9.91174 3.79224L9.92546 3.82865C10.0575 4.17893 10.1662 4.46493 10.2843 4.69382C10.4143 4.94591 10.5969 5.22559 10.8182 5.56337L10.853 5.61641C11.5949 6.74781 12.6856 8.41096 12.0652 10.4854C11.2219 13.3052 7.26125 14.5229 4.39157 12.1639C1.21033 9.54876 1.42082 6.08142 2.35526 3.80345ZM6.32064 1.75016C5.04561 1.75016 4.05212 2.74092 3.43464 4.24621C2.62263 6.22573 2.47587 9.07883 5.13243 11.2627C7.46522 13.1803 10.3816 12.0433 10.9475 10.1511C11.4018 8.63184 10.6259 7.39845 9.84243 6.20284L9.83183 6.18667C9.62327 5.86845 9.40827 5.54038 9.24749 5.22881C9.09507 4.93343 8.96418 4.58615 8.84109 4.25957L8.83377 4.24016C8.58439 3.57857 8.34427 2.95689 7.95925 2.48829C7.60419 2.05615 7.1214 1.75016 6.32064 1.75016Z"
              fill="#616366"
            />
          </svg>
          {$t((v) => v.Label_MeidouPrefix)}
          <span
            className={styles.number}
            onClick={() => {
              handleMeidouInfoClick();
            }}
          >
            {meidouTotal}
          </span>
        </div>
        {subscribeType !== SubscribeType.MEIDOU_ONLY && (
          <div className={styles.switchBtn} onClick={handleSwitch}>
            {TabType.MEIDOU === curTab
              ? $t((v) => v.Button_BuyMember)
              : $t((v) => v.Button_BuyMeidou)}
            <img className={styles.icon} alt="" src={ArrowImg} />
          </div>
        )}
      </>
    );
  };

  const showVipTag =
    hasFetchUserInfo && userInfo?.id && !getVipTag(vipInfo).hasNoBuy && type !== 'svip'; // 非批处理

  const avatar = userInfo?.avatar;
  const name = userInfo?.screen_name;

  const vipTag = useMemo(() => {
    const { proVip, svip, vip } = getVipTag(vipInfo);

    if (proVip) return Pro;
    if (svip) return Vip;

    return NoVip;
  }, [vipInfo]);

  const handleClickInvoicing = useCallback(() => {
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: { class: '我要开票' },
    });
    if (!userInfo?.id) {
      message.warning($t((v) => v.Text_PleaseLoginFirst));
      return;
    }
    setVisibleInvoicing(true);
  }, [userInfo]);

  const handleClickExchange = useCallback(() => {
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: { class: '兑换码开通' },
    });
    if (!userInfo?.id) {
      handleJumpLogin();
      return;
    }
    setVisibleExchange(true);
  }, [userInfo]);

  const renderFeatureEntrances = () => {
    if (curTab === TabType.MEIDOU) return null;

    return (
      <div className={styles.featureEntrances}>
        <span className={styles.featureEntrance} onClick={handleClickInvoicing}>
          {$t((v) => v.Button_ApplyInvoice)}
        </span>
        <span className={styles.featureEntranceDivider}>|</span>
        <span className={styles.featureEntrance} onClick={handleClickExchange}>
          {$t((v) => v.Button_InviteOrRedeemCode)}
        </span>
      </div>
    );
  };

  return (
    <>
      <div className={styles.module}>
        <div
          className={classNames(styles.avatarBox, {
            [styles.avatarVip]: vipInfo?.is_vip,
            [styles.avatarNoVip]: !getVipTag(vipInfo).hasNoBuy && !vipInfo?.is_vip,
          })}
        >
          {avatar ? (
            <img
              className={styles.avatar}
              src={avatar || AvatarDefault}
              alt=""
              onClick={handleJumpAccount}
            />
          ) : (
            <div
              className={classNames(styles.defaultAvatar, !hasFetchUserInfo && styles.skeleton)}
              style={{ cursor: 'pointer' }}
              onClick={handleJumpLogin}
            ></div>
          )}
          {showVipTag ? <img className={styles.vipIcon} src={vipTag} alt="" /> : null}
        </div>
        <div className={styles.right}>
          {userInfo?.id ? (
            <div className={styles.rightTop}>
              <div className={styles.username} onClick={handleJumpAccount}>
                {name}
              </div>
              {renderFeatureEntrances()}
            </div>
          ) : (
            <div
              className={classNames(styles.username, !hasFetchUserInfo && styles.skeleton)}
              onClick={handleJumpLogin}
            >
              {$t((v) => v.Button_ClickLoginRegister)}
            </div>
          )}

          {hasFetchUserInfo && renderDesc() ? (
            <div className={styles.bottom}>{renderDesc()}</div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default React.memo(Userinfo);
